import type { BlockOptionDefinition } from '../../node_modules/@blokkli/editor/dist/runtime/types/blokkOptions.ts'

type GlobalOptionsDefaults = {
  type: BlockOptionDefinition['type']
  default: any
}

export const bundlesWithVisibleLanguage: string[] = []
export const bundlesWithHiddenGlobally: string[] = ["accordion","accordion","address","address_list","datawrapper","dynamics_365","guidle","iframe","image","image","issuu","link","link","logo","logo_list","quote","remote_video","slider","teaser","teaser","teaser_list","text","text_image_box","title","two_columns","video","toggle","webcam","webform"]

export const globalOptionsDefaults: Record<string, GlobalOptionsDefaults> = {
  "bkVisibleLanguages": {
    "default": [],
    "type": "checkboxes"
  },
  "bkHiddenGlobally": {
    "default": false,
    "type": "checkbox"
  },
  "publicationChannels": {
    "default": [
      "app",
      "web"
    ],
    "type": "checkboxes"
  },
  "showAnchor": {
    "default": false,
    "type": "checkbox"
  },
  "contextToggleId": {
    "default": "",
    "type": "text"
  },
  "isHero": {
    "default": false,
    "type": "checkbox"
  }
} as const